/* 検索項目 テキスト入力 */
import React, { memo } from 'react';
import SearchLabel from '../atoms/SearchLabel';
import { Col } from 'react-bootstrap';
import { nullChecker } from '../Common';
import Messages from '../molecules/Messages';
var SearchInput = function (_a) {
    var id = _a.id, class_name = _a.class_name, name = _a.name, label = _a.label, value = _a.value, column = _a.column, help_message = _a.help_message, onChange = _a.onChange, onBlur = _a.onBlur;
    return (React.createElement(Col, { md: column ? column : 4 },
        React.createElement(SearchLabel, { label: label }),
        React.createElement("input", { id: id, className: class_name ? "search-form-input " + class_name : 'search-form-input long', name: name !== null && name !== void 0 ? name : '', type: "text", onChange: onChange, value: value, onBlur: onBlur }),
        nullChecker(help_message) && React.createElement(Messages, { help_msg: help_message })));
};
export default memo(SearchInput);
